module.exports = __webpack_public_path__ + "media/img/home/btn_next-8a389561657597cbd1d8a2388af7ac61.png";